import Spinner from "../../components/Tools/spinner";
import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import { exportSubActivityDetailedPPAOverviewReport, exportSubActivityDetailedPPAReport } from "../../helper/Api";
import MainFilter from "../../components/Tools/MainFilter";
import { toast } from "react-toastify";
import DashboardFilter from "../Dashboard/components/DashboardFilter";
import moment from "moment";
import ExportConsolidatePpaPdfButton from "../../components/Ppa/ExportConsolidatePpaPdfButton";

export default function ConsolidarePpa() {
    const [loading, setLoading] = useState(false);
    const { authData, financialYears } = useSelector((state) => state.authData);
    const [open, setOpen] = useState(false);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem("globalDateId"));
    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem("globalDateId");
      };
    const [activeCard, setActiveCard] = useState([]);
    const [activeSchemeTab, setActiveSchemeTab] = useState({});
    const [openDepartmentCards, setOpenDepartmentCards] = useState({});
    const [openSchemeCards, setOpenSchemeCards] = useState({});
    const [departments, setDepartments] = useState([]);
    const [ppaExportErrors, setPpaExportErrors] = useState({});
    const ppaExportUrl = useRef("");
    const [ppaExportSubmitting, setPpaExportSubmitting] = useState(false);
    const [filterPayload, setFilterPayload] = useState({
      fromDate: "",
      toDate: ""
  });
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    function getFyStartYearFromDate(dateStr) {
      if (!dateStr) return null;
      const [y, m] = String(dateStr).split("-").map((v) => Number(v));
      if (!y || !m) return null;
      return m >= 4 ? y : y - 1;
    }

    const toNum = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };
    const calculateSchemeExpense = (schemes, key) => {
        let value = 0;
        schemes.forEach((scheme) => {
          value += scheme[key];
        });
        return value;
      };

    const getDeptKey = (dept, deptIndex) =>
      dept?.department_id ??
      dept?.departmentId ??
      dept?.id ??
      `${deptIndex}_${dept?.department_name ?? "dept"}`;

    const getSchemeUniq = (scheme, schemeIndex) =>
      scheme?.id ??
      scheme?.scheme_id ??
      scheme?.schemeId ??
      scheme?.code ??
      schemeIndex;

    const getSchemeKey = (dept, deptIndex, scheme, schemeIndex) =>
      `${getDeptKey(dept, deptIndex)}_${getSchemeUniq(scheme, schemeIndex)}`;

    const areAllCardsOpen = (() => {
      if (!departments?.length) return false;
      for (let di = 0; di < departments.length; di++) {
        const dept = departments[di];
        const deptKey = getDeptKey(dept, di);
        if (!openDepartmentCards[deptKey]) return false;
        const schemes = dept?.schemes ?? [];
        for (let si = 0; si < schemes.length; si++) {
          const schemeKey = getSchemeKey(dept, di, schemes[si], si);
          if (!openSchemeCards[schemeKey]) return false;
        }
      }
      return true;
    })();

    const handleToggleAll = () => {
      const nextOpen = !areAllCardsOpen;
      if (!nextOpen) {
        setOpenDepartmentCards({});
        setOpenSchemeCards({});
        return;
      }

      const nextDeptOpen = {};
      const nextSchemeOpen = {};
      departments.forEach((dept, di) => {
        const deptKey = getDeptKey(dept, di);
        nextDeptOpen[deptKey] = true;
        (dept?.schemes ?? []).forEach((scheme, si) => {
          nextSchemeOpen[getSchemeKey(dept, di, scheme, si)] = true;
        });
      });
      setOpenDepartmentCards(nextDeptOpen);
      setOpenSchemeCards(nextSchemeOpen);
    };

    const mainCardSwitch = (val1, val2, val3, detailObj) => {
        setActiveCard((prev) => {
          let updated = [...prev];
          // Remove val2 and val3 if present
          updated = updated.filter((item) => item !== val2 && item !== val3);
          // Add val1 if not already present
          if (!updated.includes(val1)) {
            updated.unshift(val1); // Add at the beginning
          }
          return updated;
        });
      };

    const getIndianFYStartYear = (dateStr) => {
      const d = new Date(dateStr);
      if (Number.isNaN(d.getTime())) return null;
      const y = d.getFullYear();
      const m = d.getMonth() + 1; // 1-12
      // Indian FY runs Apr 1 -> Mar 31. FY start year is the year of April.
      return m >= 4 ? y : y - 1;
    };

    const clearDateFilters = () => {
      setFilterPayload((prev) => ({
        ...prev,
        fromDate: "",
        toDate: "",
      }));
    };

    const handleFilterClick = async () => {
      setOpen(false);
      try {
        console.log(filterPayload);
        if (!filterPayload?.fromDate) {
          toast.error("From date is required", { position: toast.POSITION.TOP_CENTER });
          return;
        }
        if (!filterPayload?.toDate) {
          toast.error("To date is required", { position: toast.POSITION.TOP_CENTER });
          clearDateFilters();
          return;
        }

        const fromFY = getIndianFYStartYear(filterPayload.fromDate);
        const toFY = getIndianFYStartYear(filterPayload.toDate);
        if (fromFY == null || toFY == null) {
          toast.error("Invalid date selected", { position: toast.POSITION.TOP_CENTER });
          clearDateFilters();
          return;
        }
        if (fromFY !== toFY) {
          toast.error(
            "From date and To date should be in the same Indian financial year",
            { position: toast.POSITION.TOP_CENTER }
          );
          clearDateFilters();
          return;
        }

        setLoading(true);
        const response = await exportSubActivityDetailedPPAOverviewReport(
          authData.user.department_details.id,
          filterPayload.fromDate,
          filterPayload.toDate
        );
        if (response.data.status) {
          setDepartments(response.data.result);
        } else {
          toast.error(response.data.error, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      } catch (error) {
        toast.error('Something went wrong!', {
          position: toast.POSITION.TOP_CENTER
        });
        setLoading(false);
      }
      finally {
        setLoading(false);
      }
  };

  const handleFilterRemove = async (name) => {
      const newPayload = {
      ...filterPayload,
      [name]: "",
    };
    setFilterPayload(newPayload);
    if (newPayload?.fromDate && newPayload?.toDate) {
      handleFilterClick();
    }
  }

  const ALLOWED_HOSTS = [
    "tangy-media-sms.s3.ap-south-1.amazonaws.com"
  ];

  const downloadFile = (url) => {
    try {
        if (!url) {
        throw new Error("Empty URL");
        }

        const parsedUrl = new URL(url);

        // allow only https
        if (parsedUrl.protocol !== "https:") {
        throw new Error("Invalid protocol");
        }

        // allow only trusted domains
        if (!ALLOWED_HOSTS.includes(parsedUrl.hostname)) {
        throw new Error("Untrusted download source");
        }

        const link = document.createElement("a");
        link.href = parsedUrl.href;
        link.download = "PPA-Subactivity-Expense.xlsx";
        link.rel = "noopener noreferrer";
        link.target = "_blank";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (err) {
        toast.error("Invalid or unsafe download URL", {
        position: toast.POSITION.TOP_CENTER
        });
    }
};


  const handlePpaExportSubmit = async () => {
    const errors = {};
    const fromDate = filterPayload?.fromDate || "";
    const toDate = filterPayload?.toDate || "";

    if (!fromDate) errors.fromDate = "From date is required";
    if (!toDate) errors.toDate = "To date is required";

    if (Object.keys(errors).length) {
      setPpaExportErrors(errors);
      toast.error("Please select both From Date and To Date", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (fromDate > toDate) {
      setPpaExportErrors({
        fromDate: "From date cannot be greater than To date",
        toDate: "To date cannot be less than From date",
      });
      toast.error("From Date should be less than or equal to To Date", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    const fromFyStart = getFyStartYearFromDate(fromDate);
    const toFyStart = getFyStartYearFromDate(toDate);
    if (fromFyStart && toFyStart && fromFyStart !== toFyStart) {
      const fromLabel = `${fromFyStart}-${fromFyStart + 1}`;
      const toLabel = `${toFyStart}-${toFyStart + 1}`;
      setPpaExportErrors({
        fromDate: `From date is in FY ${fromLabel}`,
        toDate: `To date is in FY ${toLabel}`,
      });
      toast.error("Both dates should be from same financial year", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    try {
      setLoading(true);
      setPpaExportSubmitting(true);
      const res = await exportSubActivityDetailedPPAReport(
        authData.user.department_details.id,
        fromDate,
        toDate
      );
      if (res?.data?.status === false) {
        toast.error(res?.message || "Something Went Wrong", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }
      ppaExportUrl.current = res?.data?.url;
      downloadFile(ppaExportUrl.current);
    //   closePpaExportModal();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setPpaExportSubmitting(false);
      toast.error("Something Went Wrong", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Consolidate PPA Report</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Consolidate PPA Report"/>
                </div>
                <div className="col-md-6">
                  <div className="m-0 p-0 d-flex gap-2" style={{ width: "auto", float: "right" }}>
                    <ExportConsolidatePpaPdfButton
                      departments={departments}
                      fromDate={filterPayload?.fromDate}
                      toDate={filterPayload?.toDate}
                    />
                    {departments?.length > 0 || (filterPayload?.fromDate && filterPayload?.toDate) ? (
                      <button
                        className="navigation_button"
                        onClick={handlePpaExportSubmit}
                        type="button"
                      >
                        Export to Excel
                      </button>
                    ) : null}
                    {departments?.length > 0 ? (
                      <div className="d-flex align-items-center gap-2 bg-white border-Prime-100 px-3 py-2 rounded-3">
                        <span className="fs-12px text-secondary-100 fw-500">
                          {areAllCardsOpen ? "Close all" : "Open all"}
                        </span>
                        <div className="form-check form-switch m-0">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            role="switch"
                            checked={areAllCardsOpen}
                            onChange={handleToggleAll}
                            aria-label={areAllCardsOpen ? "Close all cards" : "Open all cards"}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
            </div>

            <DashboardFilter 
            openFilterModal={setOpen} 
            filterPayload={filterPayload} 
            handleFilterRemove={handleFilterRemove} />
            
            <div className="row">
              <div
                className="px-3 col-12 d-flex flex-column gap-3 overflow-y-auto overflow-x-hidden"
                style={{ height: "100vh" }}
              >
                {departments.map((e, index) => {
                  const deptKey = getDeptKey(e, index);
                  const isDeptOpen = !!openDepartmentCards[deptKey];

                  return (
                  <div
                    className="bg-white border-Prime-100 my-2 p-0"
                    style={{ borderRadius: "8px" }}
                    key={deptKey}
                  >
                    <div
                      className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden"
                      style={{ borderRadius: "8px 8px 0 0" }}
                    >
                      {/* ======================card header================== */}
                      <span
                        className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                        style={{ width: "95%", fontStyle: "italic" }}
                      >
                        {/* =======================card header====================== */}
                        <span
                          className="fs-14px white-space-nowrap overflow-x-hidden"
                          style={{ width: "95%", fontStyle: "italic" }}
                        >
                          <span className="fw-500 text-secondary-100">
                            {e.department_name}
                          </span>
                        </span>
                      </span>
                      <button
                        type="button"
                        className="border-0 bg-transparent p-0 m-0 d-flex align-items-center"
                        onClick={() =>
                          setOpenDepartmentCards((prev) => ({
                            ...prev,
                            [deptKey]: !prev[deptKey],
                          }))
                        }
                        aria-label={isDeptOpen ? "Collapse department" : "Expand department"}
                      >
                        <i
                          className={`icon-keyboard_arrow_${
                            isDeptOpen ? "down" : "right"
                          } cursor-pointer fs-18px text-secondary-100`}
                        ></i>
                      </button>
                    </div>

                    {isDeptOpen ? (
                      <>
                        <div className="row py-2 px-3">
                          <div className="col-md-2"></div>
                          <div className="col-md-2">
                            <div className="light-green-div bg-success-20">
                              <span className="fw-500 fs-12px">
                                Prov. Budget {" "} <br />
                                <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                <br />
                                <span className="fs-18px text-success-100">
                                  {calculateSchemeExpense(e.schemes, "provisional_budget").toLocaleString("en-IN")}
                                </span>
                              </span>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="light-green-div bg-success-20">
                              <span className="fw-500 fs-12px">
                                Released Budget FY{" "} <br />
                                <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                              </span>{" "}
                              <br />
                              <span className="fs-18px text-success-100">
                                {calculateSchemeExpense(e.schemes, "budget").toLocaleString("en-IN")}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-2"></div>
                          <div className="col-md-2">
                            <div
                              className="light-green-div"
                              style={{ backgroundColor: "#28316f" }}
                            >
                              <span
                                className="fw-500 fs-12px"
                                style={{ color: "#ffffff" }}
                              >
                                Expense Budget FY{" "} <br />
                                <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                              </span>{" "}
                              <br />
                              <span className="fs-18px" style={{ color: "#ffffff" }}>
                                {calculateSchemeExpense(e.schemes, "expense").toLocaleString("en-IN")}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="light-green-div bg-success-100">
                              <span
                                className="fw-500 fs-12px"
                                style={{ color: "#ffffff" }}
                              >
                                Balance FY{" "} <br />
                                <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                <br />
                                <span className="fs-18px" style={{ color: "#ffffff" }}>
                                  {calculateSchemeExpense(e.schemes, "balance").toLocaleString("en-IN")}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {
                          e.schemes.map((scheme, schemeIndex) => {
                            const schemeKey = getSchemeKey(e, index, scheme, schemeIndex);
                            const isSchemeOpen = !!openSchemeCards[schemeKey];
                            const schemeName = scheme?.name;

                            return (
                              <div className="ppa_scheme_card bg-white m-1 p-0" key={schemeKey}>
                                {/* scheme details starts */}
                                <div className="bg-secondary-20 d-flex justify-content-between align-items-center p-1 transition overflow-hidden">
                                  {/* ======================card header================== */}
                                  <span
                                    className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                                    style={{ width: "95%", fontStyle: "italic" }}
                                  >
                                    {/* =======================card header====================== */}
                                    <span
                                      className="fs-12px white-space-nowrap overflow-x-hidden"
                                      style={{ width: "95%", fontStyle: "italic" }}
                                    >
                                      <span className="fw-500 text-secondary-100">
                                        {schemeName}
                                      </span>
                                    </span>
                                  </span>
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent p-0 m-0 d-flex align-items-center"
                                    onClick={() =>
                                      setOpenSchemeCards((prev) => ({
                                        ...prev,
                                        [schemeKey]: !prev[schemeKey],
                                      }))
                                    }
                                    aria-label={isSchemeOpen ? "Collapse scheme" : "Expand scheme"}
                                  >
                                    <i
                                      className={`icon-keyboard_arrow_${
                                        isSchemeOpen ? "down" : "right"
                                      } cursor-pointer fs-18px text-secondary-100`}
                                    ></i>
                                  </button>
                                </div>

                                {isSchemeOpen ? (
                                  <>
                                    <div className="row py-2 px-3">
                                      <div className="col-md-2"></div>
                                      <div className="col-md-2">
                                        <div className="light-green-div bg-success-20">
                                          <span className="fw-500 fs-12px">
                                            Prov. Budget FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                            <br />
                                            <span className="fs-18px text-success-100">
                                              {scheme.provisional_budget.toLocaleString("en-IN")}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-md-2">
                                        <div className="light-green-div bg-success-20">
                                          <span className="fw-500 fs-12px">
                                            Released Budget FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                          </span>{" "}
                                          <br />
                                          <span className="fs-18px text-success-100">
                                            {scheme.budget.toLocaleString("en-IN")}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-md-2"></div>
                                      <div className="col-md-2">
                                        <div
                                          className="light-green-div"
                                          style={{ backgroundColor: "#28316f" }}
                                        >
                                          <span
                                            className="fw-500 fs-12px"
                                            style={{ color: "#ffffff" }}
                                          >
                                            Expense Budget FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                          </span>{" "}
                                          <br />
                                          <span className="fs-18px" style={{ color: "#ffffff" }}>
                                          {scheme.expense.toLocaleString("en-IN")}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-md-2">
                                        <div className="light-green-div bg-success-100">
                                          <span
                                            className="fw-500 fs-12px"
                                            style={{ color: "#ffffff" }}
                                          >
                                            Balance FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                            <br />
                                            <span className="fs-18px" style={{ color: "#ffffff" }}>
                                            {scheme.balance.toLocaleString("en-IN")}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    {/* tabs starts */}
                                    <div className="px-2 m-0">
                                      <div className="border mb-2"></div>
                                      <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                        <button
                                          onClick={() =>
                                            setActiveSchemeTab((prev) => ({
                                              ...prev,
                                              [schemeKey]: "subhead",
                                            }))
                                          }
                                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                            activeSchemeTab[schemeKey] === "subhead"
                                              ? "bg-secondary-20"
                                              : "bg-white"
                                          } `}
                                        >
                                          {activeSchemeTab[schemeKey] === "subhead" ? (
                                            <i className="icon-remove_circle_outline"></i>
                                          ) : (
                                            <i className="icon-add_circle_outline"></i>
                                          )}
                                          Sub head
                                        </button>
                                        {/* <button
                                          onClick={() =>
                                            mainCardSwitch(
                                              `activity_${e.id}`,
                                              `subhead_${e.id}`,
                                              `subactivity_${e.id}`,
                                              {
                                                scheme_id: e.id,
                                                subhead: false,
                                                activity: true,
                                                subActivity: false,
                                              }
                                            )
                                          }
                                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                            activeCard.includes(`activity_${e.id}`)
                                              ? "bg-secondary-20"
                                              : "bg-white"
                                          } `}
                                        >
                                          {activeCard.includes(`activity_${e.id}`) ? (
                                            <i className="icon-remove_circle_outline"></i>
                                          ) : (
                                            <i className="icon-add_circle_outline"></i>
                                          )}
                                          Activity
                                        </button> */}
                                        {((Number(scheme.is_activity_active) === 1 && Number(scheme.monitoring_level) === 1) || (Number(scheme.is_activity_active) === 1 && Number(scheme.monitoring_level) === 3 && authData.user.department_details.department_level != 'T1')) &&
                                        <button
                                          onClick={() =>
                                            setActiveSchemeTab((prev) => ({
                                              ...prev,
                                              [schemeKey]: "subactivity",
                                            }))
                                          }
                                          className={` ${
                                            activeSchemeTab[schemeKey] === "subactivity"
                                              ? "bg-secondary-20"
                                              : "bg-white"
                                          } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                        >
                                          {activeSchemeTab[schemeKey] === "subactivity" ? (
                                            <i className="icon-remove_circle_outline"></i>
                                          ) : (
                                            <i className="icon-add_circle_outline"></i>
                                          )}
                                          Sub-Activity
                                        </button> }
                                      </div>
                                    </div>
                                    {/* tabs ends */}

                                    {activeSchemeTab[schemeKey] === "subhead" ? (
                                    <div className="subhead_card p-1">
                                      <div className="consolidate_ppa_table_wrapper">
                                        <table className="consolidate_ppa_table" border="1">
                                          <tbody>
                                          <tr>
                                            <td
                                              rowSpan={3}
                                              style={{ width: "200px", minWidth: "200px", backgroundColor: "#28316f", color: "white" }}
                                            >
                                              Caption
                                            </td>
                                            <td rowSpan={3} style={{ width: "100px", minWidth: "100px", backgroundColor: "#28316f", color: "white" }}>
                                              Provisioned Budget
                                            </td>
                                            <td style={{ backgroundColor: "#e9baea" }}>1</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>2</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>3</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>4</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>5(1+2+3+4)</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>6</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>7</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>8</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>9(6+7+8)</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>10(5-9)</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>11</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>12</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>13</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>14(11+12+13)</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>15</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>16(14+15)</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>17(10-16)</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>18</td>
                                            <td style={{ backgroundColor: "#e9baea" }}>19</td>
                                          </tr>
                                          <tr className="consolidate_ppa_header">
                                            <td colSpan={5}>Budget Received</td>
                                            <td colSpan={4}>Budget Transferred</td>
                                            <td></td>
                                            <td colSpan={5}>PPA Payment</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                          </tr>
                                          <tr className="consolidate_ppa_header">
                                            <td>Opening Balance</td>
                                            <td>Release Budget</td>
                                            <td>Reappropriation Budget</td>
                                            <td>Surrender Budget</td>
                                            <td>Total Budget</td>
                                            <td>Limit Allocated to child</td>
                                            <td>Reappropriation transferred</td>
                                            <td>Surrender to parent</td>
                                            <td>Total Budget Transferred</td>
                                            <td>Budget / Limit Allowed</td>
                                            <td>Vendor</td>
                                            <td>DBT</td>
                                            <td>Salary</td>
                                            <td>Total Successfully Payment</td>
                                            <td>PPA (Under Approval)</td>
                                            <td>Total Budget</td>
                                            <td>Balance on (Date)</td>
                                            <td>Commulative</td>
                                            <td>Commulative Expenditure</td>
                                          </tr>
                                          {
                                            scheme.sub_head_list.map((subhead, subheadIndex) => {
                                              const openingBalance = toNum(subhead.openingBalance);
                                              const budget = toNum(subhead.budget);
                                              const reappropriateReceived = toNum(subhead.reappropriate_received);
                                              const surrenderReceived = toNum(subhead.surrender_received);
                                              const totalBudgetReceived =
                                                openingBalance +
                                                budget +
                                                reappropriateReceived +
                                                surrenderReceived;

                                              const allocation = toNum(subhead.allocation);
                                              const reappropriateGiven = toNum(subhead.reappropriate_given);
                                              const surrenderGiven = toNum(subhead.surrender_given);
                                              const totalBudgetTransferred =
                                                allocation + reappropriateGiven + surrenderGiven;

                                              const budgetAllowed =
                                                totalBudgetReceived - totalBudgetTransferred;

                                              const vendor = toNum(subhead.vendor);
                                              const dbt = toNum(subhead.dbt);
                                              const salary = toNum(subhead.salary);
                                              const totalSuccessfulPayment = vendor + dbt + salary;

                                              const pendingPPA = toNum(subhead.pendingPPA);
                                              const totalPpaPayment = totalSuccessfulPayment + pendingPPA;

                                              const balanceOnDate = budgetAllowed - totalPpaPayment;

                                              return (
                                                <tr key={subheadIndex}>
                                                  <td>{subhead.name}</td>
                                                  <td>{subhead.provisional_budget || 0}</td>
                                                  <td>{openingBalance}</td>
                                                  <td>{budget}</td>
                                                  <td>{reappropriateReceived}</td>
                                                  <td>{surrenderReceived}</td>
                                                  <td>{totalBudgetReceived}</td>
                                                  <td>{allocation}</td>
                                                  <td>{reappropriateGiven}</td>
                                                  <td>{surrenderGiven}</td>
                                                  <td>{totalBudgetTransferred}</td>
                                                  <td>{budgetAllowed}</td>
                                                  <td>{vendor}</td>
                                                  <td>{dbt}</td>
                                                  <td>{salary}</td>
                                                  <td>{totalSuccessfulPayment}</td>
                                                  <td>{pendingPPA}</td>
                                                  <td>{totalPpaPayment}</td>
                                                  <td>{balanceOnDate}</td>
                                                  <td>-</td>
                                                  <td>-</td>
                                                </tr>
                                              )
                                            })
                                          }
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    ) : null}
                                    {/* subactivity starts */}
                                    {((Number(scheme.is_activity_active) === 1 && Number(scheme.monitoring_level) === 1) || (Number(scheme.is_activity_active) === 1 && Number(scheme.monitoring_level) === 3 && authData.user.department_details.department_level != 'T1')) && <>
                                      {activeSchemeTab[schemeKey] === "subactivity" ? (
                                      <div className="subactivity_card">
                                        {
                                              scheme.sub_head_list.map((subhead, subheadIndex) => {
                                                return (
                                                  <div key={subheadIndex}>
                                                    <div className="bg-success-20 d-flex justify-content-between align-items-center p-1 transition overflow-hidden">
                                                      {/* ======================card header================== */}
                                                      <span
                                                        className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                                                        style={{ width: "95%", fontStyle: "italic" }}
                                                      >
                                                        {/* =======================card header====================== */}
                                                        <span
                                                          className="fs-12px white-space-nowrap overflow-x-hidden"
                                                          style={{ width: "95%", fontStyle: "italic" }}
                                                        >
                                                          <span className="fw-500 text-success-100">
                                                            {subhead.name}
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div className="consolidate_ppa_table_wrapper">
                                                      <table className="consolidate_ppa_table" border="1" style={{margin: "5px"}}>
                                                        <tbody>
                                                          <tr>
                                                            <td
                                                              rowSpan={3}
                                                              style={{ width: "100px", minWidth: "100px", backgroundColor: "#28316f", color: "white" }}
                                                            >
                                                              Activity
                                                            </td>
                                                            <td
                                                              rowSpan={3}
                                                              style={{ width: "100px", minWidth: "100px", backgroundColor: "#28316f", color: "white" }}
                                                            >
                                                              Sub-Activity
                                                            </td>
                                                            <td rowSpan={3} style={{ width: "100px", minWidth: "100px", backgroundColor: "#28316f", color: "white" }}>
                                                              Provisioned Budget
                                                            </td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>1</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>2</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>3</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>4</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>5(1+2+3+4)</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>6</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>7</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>8</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>9(6+7+8)</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>10(5-9)</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>11</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>12</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>13</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>14(11+12+13)</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>15</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>16(14+15)</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>17(10-16)</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>18</td>
                                                            <td style={{ backgroundColor: "#e9baea" }}>19</td>
                                                          </tr>
                                                          <tr className="consolidate_ppa_header">
                                                            <td colSpan={5}>Budget Received</td>
                                                            <td colSpan={4}>Budget Transferred</td>
                                                            <td></td>
                                                            <td colSpan={5}>PPA Payment</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                          </tr>
                                                          <tr className="consolidate_ppa_header">
                                                            <td>Opening Balance</td>
                                                            <td>Release Budget</td>
                                                            <td>Reappropriation Budget</td>
                                                            <td>Surrender Budget</td>
                                                            <td>Total Budget</td>
                                                            <td>Limit Allocated to child</td>
                                                            <td>Reappropriation transferred</td>
                                                            <td>Surrender to parent</td>
                                                            <td>Total Budget Transferred</td>
                                                            <td>Budget / Limit Allowed</td>
                                                            <td>Vendor</td>
                                                            <td>DBT</td>
                                                            <td>Salary</td>
                                                            <td>Total Successfully Payment</td>
                                                            <td>PPA (Under Approval)</td>
                                                            <td>Total Budget</td>
                                                            <td>Balance on (Date)</td>
                                                            <td>Commulative</td>
                                                            <td>Commulative Expenditure</td>
                                                          </tr>
                                                          {
                                                            subhead.activity_budget.map((activity, activityIndex) => {
                                                              return (
                                                                <tr>
                                                                  <td>{activity?.activity}</td>
                                                                  <td>{activity?.subactivity}</td>
                                                                  <td>{activity?.provisional_budget}</td>
                                                                  <td>{activity?.openingBalance}</td>
                                                                  <td>{activity?.budget}</td>
                                                                  <td>{activity?.reappropriate_received}</td>
                                                                  <td>{activity?.surrender_received}</td>
                                                                  <td>{activity?.openingBalance + activity?.budget + activity?.reappropriate_received + activity?.surrender_received}</td>
                                                                  <td>{activity?.allocation}</td>
                                                                  <td>{activity?.reappropriate_subtraction}</td>
                                                                  <td>{activity?.surrender_done}</td>
                                                                  <td>{activity?.allocation + activity?.reappropriate_subtraction + activity?.surrender_done}</td>
                                                                  <td>{(activity?.openingBalance + activity?.budget + activity?.reappropriate_received + activity?.surrender_received)
                                                                    - (activity?.allocation + activity?.reappropriate_subtraction + activity?.surrender_done)}</td>
                                                                  <td>{activity?.vendor}</td>
                                                                  <td>{activity?.dbt}</td>
                                                                  <td>{activity?.salary}</td>
                                                                  <td>{activity?.vendor + activity?.dbt + activity?.salary}</td>
                                                                  <td>{activity?.pending_ppa}</td>
                                                                  <td>{activity?.vendor + activity?.dbt + activity?.salary + activity?.pending_ppa}</td>
                                                                  <td>{((activity?.openingBalance + activity?.budget + activity?.reappropriate_received + activity?.surrender_received)
                                                                    - (activity?.allocation + activity?.reappropriate_subtraction + activity?.surrender_done)) - (activity?.vendor + activity?.dbt + activity?.salary + activity?.pending_ppa)}</td>
                                                                  <td></td>
                                                                  <td></td>
                                                                </tr>
                                                              )
                                                            })
                                                          }
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                )
                                              })
                                        }
                                      <div>
                                      
                                        </div>
                                        
                                      </div>
                                      ) : null}
                                      </>
                                    }
                                  </>
                                ) : null}
                              </div>
                            );
                          })
                        }
                      </>
                    ) : null}
                    
                  </div>
                  );
                })}
              </div>
            </div>


            <MainFilter 
              open={open} 
              handleClose={handleClose} 
              handleInput={handleInput} 
              handleOpen={handleOpen}
              filterPayload={filterPayload}
              handleFilterClick={handleFilterClick}
              type={"consolidatePPAExpenseReport"}
            />

        </div>
    )
}